import { showServicesCart, showSuccess } from '@context/actions';
import { replaceAppointmentServices } from '@context/actions/appointment';
import { navigateTo } from '@util/routerService';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CloseIcon,
  IconFrame,
} from '@element/icons';
function ServicesCartModal() {
    const modalRef = useRef(null);
    const [modalHeight, setModalHeight] = useState<any>('300px');
    const dispatch = useDispatch();
    const appointmentItems = useSelector((state: any) => state.appointmentServices);
    const store = useSelector((state: any) => state);
    const languageData: any = store.languageKeywords
    const onOutsideClick = (event: any) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            closeModal();
        }
    }
    const activeLanguage: any = store.activeLanguage
    useEffect(() => {
        if (appointmentItems.length == 0) dispatch(showServicesCart(false));
    }, [appointmentItems])

    const closeModal = () => {
        dispatch(showServicesCart(false))
    }

    const getSelectedVariationObj = (service) => {
        const selectedVariations = { variant: '', subVariant: '', subSubVariant: '', }
        if (service.variations?.length != 0) {
            let vObj = service.variations[0];
            selectedVariations.variant = vObj.name;//weekdays or weekend
            if (vObj.variations?.length != 0) {
                vObj = vObj.variations[0]
                selectedVariations.subVariant = vObj.name;//male or female
            }
            if (vObj.variations?.length != 0) {
                vObj = vObj.variations[0]
                selectedVariations.subSubVariant = vObj.name;//adult or kids
            }
        }
        return { ...selectedVariations };
    }

    const removeFromAppointment = (item: any) => {
        const appointmentItemsCopy = appointmentItems ? [...appointmentItems] : [];
        let cartItemIndex = null;
        appointmentItems.map((appointentItem, i) => {
            if ((appointentItem.id == item?.id)) {//get list of cart items having same service data as current pdp item
                if (appointentItem.variations?.length != 0) {
                    const cartVariations = getSelectedVariationObj(appointentItem);
                    if (JSON.stringify(cartVariations) === JSON.stringify(item.variations)) {//check for item of same service and selected variations
                        cartItemIndex = i;
                    }
                } else {
                    cartItemIndex = i;
                }
            }
        })
        appointmentItemsCopy.splice(cartItemIndex, 1);
        dispatch(replaceAppointmentServices(appointmentItemsCopy));
        dispatch(showSuccess(`${languageData['Service Removed'] ? languageData['Service Removed'] : 'Service Removed'}`, 2000));
    }

    return (
        <div className='services-cart-modal-wrap backdrop-modal-wrapper'
            onClick={onOutsideClick}
            style={{
                height: `${(appointmentItems && appointmentItems.length != 0) ? 'calc(100vh - calc(100vh - 100%))' : 0}`,
                overflow: `${(appointmentItems && appointmentItems.length != 0) ? 'unset' : 'hidden'}`,
                maxHeight: `${(appointmentItems && appointmentItems.length != 0) ? 'calc(100vh - calc(100vh - 100%))' : 0}`,
                backgroundColor: '#131212b3'
            }}>
            <div className='services-cart-modal-details backdrop-modal-content' ref={modalRef}>
                <div className='heading'>
                    {languageData["Selected Services"] ? languageData["Selected Services"] : "Selected Services"}
                </div>
                <div className="modal-close" onClick={closeModal}>
                    <IconFrame width={20} height={20}><CloseIcon /></IconFrame>
                </div>
                <div className='services-list-wrap'>
                    {appointmentItems?.map((service: any) => {
                        return <div className="service-details" key={Math.random()}>
                            <div className="service-name">{service?.languages && service?.languages[activeLanguage.languageId] ? service.languages[activeLanguage.languageId].name : service.name}
                                {service.variations && service.variations[0] && <>
                                    &nbsp;- {service.variations[0]?.name}
                                </>}
                            </div>
                            <div className="remove-service" onClick={() => removeFromAppointment(service)}>{languageData["Delete"] ? languageData["Delete"] : "Delete"}</div>
                        </div>
                    })}
                </div>
                <div className="btn-wrap">
                    {/* <div className="primary-btn" onClick={closeModal}>{languageData["Add more services"] ? languageData["Add more services"] : "Add more services"}</div> */}
                    <div className="primary-btn" onClick={() => { closeModal(); navigateTo('appointment') }}>{languageData["Continue"] ? languageData["Continue"] : "Continue"}</div>
                </div>
            </div>
        </div>
    )
}

export default ServicesCartModal